<template>
	<div class="pages">
		
		<router-link :to="{name:'login'}" v-if="isLogin == 0">
			<div class="myTop-login">
				<div class="avatar flex flex-align-center flex-jus-center"><img src="@/static/images/my/avatar.png" alt="" /></div>
				<div class="des">请登录</div>
				<div class="tips">点击登录 享受更多精彩</div>
			</div>
		</router-link>
		
		<div class="myTop-member1" v-else-if="isLogin == 1">
			<div class="myTop-member1-inner">
				<!-- 个人主页 -->
				<router-link :to="{name:'my_homePage'}">
				<div class="myPage flex flex-align-center flex-jus-center">
					<div>个人主页</div>
					<img src="@/static/images/icon-arrowRight2.png" >
				</div>
				</router-link>
				
				<!-- 缴纳会费 -->
				<div class="payMoney" v-if="vip.is_pay == 0"  @click="$router.push({'name': 'my_payMoney'})">
					缴纳会费
				</div>
				
				<div class="info flex flex-align-center ">
					<div @click="openImg" class="info-avatar flex flex-align-center flex-jus-center">
						<img :src="avatar" alt="">
					</div>
					
					<div class="info-card flex flex-column flex-jus-around">
						
						<div class="name flex flex-align-center">
							<div>{{ truename || nickname }}</div>
							<img src="@/static/images/my/memberIDF.png" alt="" v-if="is_vip == 1">
						</div>
						
						<div class="edit flex flex-align-center " @click="$router.push({'name': 'my_personalInfo'})">
							<img src="@/static/images/my/edit.png" alt="">
							<div>编辑个人名片</div>
						</div>
						
					</div>
					
					
				</div>
				<div class="tips" v-if="Object.values(vip).length > 0 && vip.is_pay == 0 && is_vip != 0">
					请缴纳会费
				</div>
				<div v-else>
					<div class="tips" v-if="is_vip == 0">
						<div @click="toJoin" class="flex flex-align-center">
							<div>立即申请入会</div>
							<img src="@/static/images/icon-arrowRight2.png" class="arrow">
						</div>
						<div style="margin-top: 8px;">
							您还未加入福建省民族管弦乐学会
						</div>
					</div>
					
					<div class="tips" v-else-if="is_vip== 2">
						<div class="flex flex-align-center">
							<div>入会审核中...</div>
							<!-- <img src="@/static/images/icon-arrowRight2.png" class="arrow"> -->
						</div>
						<div style="margin-top: 8px;">
							您已提交申请，请耐心等待审核
						</div>
					</div>
					
					<div class="tips" v-else-if="is_vip == 1">
						<div class="flex flex-align-center">
							<div>{{vip.association_name}}</div>
							<!-- <img src="@/static/images/icon-arrowRight2.png" class="arrow"> -->
						</div>
						<div style="margin-top: 8px;">
							您从{{ initiation_time | formatDate_noS }}起加入学会
						</div>
					</div>

					<router-link :to="{name:'apply'}" v-if="is_vip == -1">
					<div class="tips">
						<div class="flex flex-align-center">
							<div>认证失败!</div>
						</div>
						<div style="margin-top: 8px;" class="flex flex-align-center">
							<div>
								如要再次申请入会，请重新提交
							</div>
							<img src="@/static/images/icon-arrowRight2.png" class="arrow">
						</div>
					</div>
					</router-link>
				</div>
			</div>
		</div>

		
		<div class="myBox flex flex-align-center flex-jus-between" >
			
			<router-link :to="{'name': 'watch', 'query': {'name': 'watch'}}">
			<div class="myBox-box flex flex-column">
				<div class="number">{{ concern_number }}</div>
				<div class="des">我的关注</div>
			</div>
			</router-link>
			
			<router-link :to="{'name': 'watch', 'query': {'name': 'fans'}}">
			<div class="myBox-box flex flex-column">
				<div class="number">{{ fans_number }}</div>
				<div class="des">我的粉丝</div>
			</div>
			</router-link>
		</div>
		
		
		
		<!-- <div class="lineList"  @click="$toast.fail('暂未开放！')"> -->
		<div class="lineList" >
			
			<router-link :to="{'name': 'my_certification'}">
			<div class="line flex flex-align-center">
				<img src="@/static/images/my/my-cert.png" class="icon" />
				<div class="right flex flex-align-center flex-jus-between flex-1">
					<div>我的认证</div>
					<img src="@/static/images/icon-arrowRight.png" class="arrow" />
				</div>
			</div>
			</router-link>
			<router-link :to="{'name': 'my_activity'}">
			<div class="line flex flex-align-center">
				<!-- <img src="@/static/images/my/my-cert.png" class="icon" /> -->
				<img src="@/static/images/my/my-activity.png" class="icon" />
				<div class="right flex flex-align-center flex-jus-between flex-1">
					<div>我的活动</div>
					<img src="@/static/images/icon-arrowRight.png" class="arrow" />
				</div>
			</div>
			</router-link>
			<router-link :to="{'name': 'my_collection'}">
			<div class="line flex flex-align-center">
				<img src="@/static/images/my/my-collection.png" class="icon" />
				<div class="right flex flex-align-center flex-jus-between flex-1">
					<div>我的收藏</div>
					<img src="@/static/images/icon-arrowRight.png" class="arrow" />
				</div>
			</div>
			</router-link>
			
			<div @click="toSuggest" class="line flex flex-align-center">
				<img src="@/static/images/my/my-suggest.png" class="icon" />
				<div class="right flex flex-align-center flex-jus-between flex-1">
					<div>建言献策</div>
					<img src="@/static/images/icon-arrowRight.png" class="arrow" />
				</div>
			</div>
			
			<router-link :to="{'name': 'setting'}">
			<div class="line flex flex-align-center">
				<img src="@/static/images/my/my-setting.png" class="icon" />
				<div class="right flex flex-align-center flex-jus-between flex-1">
					<div>设置</div>
					<img src="@/static/images/icon-arrowRight.png" class="arrow" />
				</div>
			</div>
			</router-link>
		</div>

		<tabbar :tabbar="4"></tabbar>
		<van-image-preview v-model="showImg" :images="imagesArr">
    </van-image-preview>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	watch: {},
	data() {
		return {
			isLogin: -1,
			avatar: '',
			nickname: '',
			truename: '',
			fans_number: 0,
			concern_number: 0,
			initiation_time: null,
			
			is_vip: 0,
			vip: {},
			is_apply: -1,
			showImg: false,
			imagesArr: [],
			needPay: false
		};
	},
	mounted() {
		if (!localStorage.getItem('TOKEN')){
			this.isLogin = 0
		}
		else {
			this.getUserInfo()
			this.isLogin = 1
		}
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	// mounted() {},
	methods: {
		getUserInfo() {
			this.$get('api/user/userInfo').then(res => {
				let result = res.data
				localStorage.setItem('user_id', result.id)
				this.avatar = result.avatar
				localStorage.setItem('avatar', this.avatar)
				this.nickname = result.nickname
				localStorage.setItem('nickname', this.nickname)
				this.truename = result.truename
				this.mobile = result.mobile
				localStorage.setItem('mobile', this.mobile)
				this.is_vip = result.is_vip
				if (!Array.isArray(result.vip)) {
					this.vip = result.vip || {}
					this.initiation_time = this.vip.initiation_time
					let next_pay_time = new Date(this.moment(this.initiation_time*1000).add(1, 'year').format('YYYY-MM-DD')).getTime()
					let now_time = new Date().getTime()
					this.needPay = now_time >= next_pay_time
				}

				this.fans_number = result.fans_number
				this.concern_number = result.concern_number
				if (this.mobile=='undefined' || this.mobile=='' || this.mobile==undefined || this.mobile==null) {
					this.$router.push({'name': 'loginPhone'})
				}
			})
		},
		openImg() {
			this.imagesArr = [this.avatar]
			this.showImg = true
		},
		toJoin() {
			let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
			} else {
				this.$router.push('/my/apply')
			}
		},
		toSuggest() {
			let Mobile = localStorage.getItem('mobile')
			if (!Mobile) {
				this.$router.push('/login/loginPhone')
			} else {
				this.$router.push('/my/suggest')
			}
		}
	}
};
</script>

<style scoped lang="stylus">
.pages
	padding-bottom 132px
.myTop-member1
	padding 24px 30px 0 30px
	.myTop-member1-inner
		width 100%
		height 320px
		background-image url('~@/static/images/my/my-topMemberBG.png')
		background-size 100% 100%
		background-position center
		position relative
		padding 28px
		.myPage
			position absolute
			right 0
			top 44px
			width: 168px;
			height: 56px;
			background: linear-gradient(270deg, #FF3B64 0%, #DE113C 100%);
			font-size: 22px;
			font-weight: 500;
			color: #FFFFFF;
			img
				width 12px
				height 20px
				margin-left 8px
		.payMoney
			position absolute
			right 24px
			bottom 38px
			width: 166px;
			height: 56px;
			line-height 56px
			text-align center
			background: rgba(255, 255, 255, 0);
			border: 2px solid #FFFFFF;
			box-shadow: 0px 12px 12px rgba(0, 0, 0, 0.04);
			border-radius: 40px;
			font-size: 26px;
			color: #FFFFFF;
		.info
			.info-avatar
				width 120px
				height 120px
				background-image url('~@/static/images/my/avatarBG.png')
				background-size 100% 100%
				background-position center
				img
					width 90px
					height 90px
					border-radius 50%
			.info-card
				margin-left 18px
				.name
					font-size: 32px;
					font-weight: 800;
					color: #FFFFFF;
					img
						width 32px
						height 32px
						margin-left 16px
				.edit
					font-size: 24px;
					color: #FFFFFF;
					margin-top 12px
					img
						width 22px
						height 22px
						margin-right 16px
		.tips
			margin-top 64px
			padding-left 12px
			font-size: 24px;
			color: #FFFFFF;
			.arrow
				width 12px
				height 22px
				margin-left 8px
.myTop-login
	width 100vw
	height 340px
	background-image url('~@/static/images/my/my-topBG.png')
	background-size 100% 100%
	background-position center
	padding-top 30px
	.avatar
		margin 0 auto
		width 120px
		height 120px
		background-image url('~@/static/images/my/avatarBG.png')
		background-size 100% 100%
		background-position center
		img
			width 90px
			height 90px
	.des
		width 100%
		text-align center
		margin-top 20px
		font-size 32px
		font-weight 800
		color #FFEBE8
	.tips
		width 100%
		text-align center
		margin-top 12px
		font-size 24px
		font-weight 500
		color #FFBCB1
.myBox
	padding 40px 30px 0 30px
	.myBox-box
		width 336px
		height 148px
		background-image url('~@/static/images/my/boxBG.png')
		background-size 100% 100%
		background-position center
		padding 22px 10px
		text-align center
		.number
			width 100%
			font-size 48px
			font-weight bold
			color #DE113C
		.des
			width 100%
			font-size 30px
			color #DE113C
.lineList
	padding 6px 30px
	.line
		font-size: 28px;
		color: #232220;
		
		.icon
			width 40px
			height 40px
			margin-right 26px
		.right
			padding 40px 0
			border-bottom 1px solid #E6E6E6
			.arrow
				width 12px
				height 24px
</style>
